module.exports = __webpack_public_path__ + "static/media/min-handout.f4ffd5d7.pdf";